module.exports = __webpack_public_path__ + "img/th.4b0a3121.svg";